<template>
<router-view></router-view>
</template>

<script>

export default {
    name: "MarketplacePage",
}
</script>

<style scoped>

</style>